// extracted by mini-css-extract-plugin
module.exports = {"listItem":"listItem__BcTto","name":"name__jppGx","badge":"badge__EnFeL"};